'use client';

import { useState } from 'react';
import { PartyPopper, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@kit/ui/button';
import { Trans } from '@kit/ui/trans';

import { CopyLinkButton } from '~/components/copy-link-button';

/**
 * Post-publish nudge shown on the listing detail page when a seller has just
 * published their FIRST active listing (`?welcome=1`, gated server-side to
 * the seller themselves). Prompts them to share their public shop URL —
 * the seller's network is the marketplace's cold-start liquidity engine
 * (WIP R4). Dismissible; purely client-side.
 */
export function ShareShopPrompt({ shareUrl }: { shareUrl: string }) {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="border-primary/30 bg-primary/5 relative mx-auto mb-6 flex max-w-3xl flex-col gap-3 rounded-lg border px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3">
        <PartyPopper className="text-primary mt-0.5 size-5 shrink-0" />
        <div>
          <p className="font-medium">
            <Trans i18nKey="explore:shareShop.title" />
          </p>
          <p className="text-muted-foreground text-sm">
            <Trans i18nKey="explore:shareShop.subtitle" />
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2 self-end sm:self-auto">
        <CopyLinkButton
          value={shareUrl}
          label={t('explore:shareShop.copyLink')}
          size="sm"
        />
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label={t('explore:shareShop.dismiss')}
          onClick={() => setDismissed(true)}
        >
          <X className="size-4" />
        </Button>
      </div>
    </div>
  );
}
